// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found_container__86xUE","link":"not-found_link__Kj6vD"};